import { useEffect } from 'react'
import { Column, Spacer } from '@smuchile/pkg-unimarc-components'
import {
  BigScreen,
  getBemId,
  SmallScreen
} from '@smuchile/pkg-unimarc-components/helpers'
import { isValidArrayWithData, useMobile } from '@smuchile/pkg-unimarc-hooks'
import productsQuantity from 'shared/utils/productsQuantity/productsQuantity'
import { ICart } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/INewCartUnimarc'
import { getCategoryFromProducts } from 'shared/helpers'
import { ProductsContainer } from './ProductsContainer'

interface ProoductsProps {
  cartData: ICart
  isLoadingByEvent: boolean
  objetSrcImagesIconAddress: {
    imgByke: string
    imgStore: string
  }
  openCollapse: boolean
  openCollapseIssues: boolean
  setLimitOnProductAlert: (value: boolean) => void
  setOpenCollapse: React.Dispatch<React.SetStateAction<boolean>>
  setOpenCollapseIssues: React.Dispatch<React.SetStateAction<boolean>>
}

export const Products = ({
  cartData,
  isLoadingByEvent,
  objetSrcImagesIconAddress,
  openCollapse,
  openCollapseIssues,
  setLimitOnProductAlert,
  setOpenCollapse,
  setOpenCollapseIssues
}: ProoductsProps): React.ReactElement => {
  const categories = getCategoryFromProducts(cartData)
  const products = isValidArrayWithData(categories?.items)
    ? categories.items
    : null
  const { innerWidth } = useMobile()
  const isMobile = innerWidth < 1280

  const saveQuantityItems = () => {
    const quantityItems = {}
    if (products) {
      products.forEach(({ description, price }) => {
        quantityItems[description?.id] = price?.unitMultiplier
      })
    }
    productsQuantity.updateProducts(quantityItems)
  }

  const handleCollapse = (open: boolean) => {
    setOpenCollapse(open)
  }

  const handleCollapseIssues = (open: boolean) => {
    setOpenCollapseIssues(open)
  }

  useEffect(() => {
    saveQuantityItems()
  }, [cartData?.products])

  useEffect(() => {
    if (isValidArrayWithData(cartData?.productsIssues?.[0]?.itemsIssues)) {
      setOpenCollapse(false)
    }
  }, [])

  return (
    <>
      <BigScreen>
        <Column
          id={getBemId('productsList', 'container')}
          isWrap
          margin='0 56px 0 0'
          maxWidth='690px'
          minWidth='690px'
          tagName='section'
        >
          <ProductsContainer
            dataCart={cartData}
            handleCollapse={handleCollapse}
            handleCollapseIssues={handleCollapseIssues}
            isLoadingByEvent={isLoadingByEvent}
            isMobile={isMobile}
            objetSrcImagesIconAddress={objetSrcImagesIconAddress}
            openCollapse={openCollapse}
            openCollapseIssues={openCollapseIssues}
            setLimitOnProductAlert={setLimitOnProductAlert}
          />
        </Column>
      </BigScreen>

      <SmallScreen>
        <Column
          id={getBemId('productsList', 'container')}
          padding='0 16px'
          tagName='section'
        >
          {cartData && <Spacer.Horizontal customSize={76} />}
          <ProductsContainer
            dataCart={cartData}
            handleCollapse={handleCollapse}
            handleCollapseIssues={handleCollapseIssues}
            isLoadingByEvent={isLoadingByEvent}
            isMobile={isMobile}
            objetSrcImagesIconAddress={objetSrcImagesIconAddress}
            openCollapse={openCollapse}
            openCollapseIssues={openCollapseIssues}
            setLimitOnProductAlert={setLimitOnProductAlert}
          />
        </Column>
      </SmallScreen>
    </>
  )
}
